var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgServiceDetailsPattern(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 560,
    height: 576,
    viewBox: "0 0 560 576",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M168.116 136.177C188.926 136.177 205.797 119.313 205.797 98.5111C205.797 77.7087 188.926 60.8451 168.116 60.8451C147.306 60.8451 130.435 77.7087 130.435 98.5111C130.435 119.313 147.306 136.177 168.116 136.177Z",
    stroke: "currentColor",
    strokeWidth: 13
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.638 162.949C116.174 152.287 99.1304 127.948 99.1304 99.67C99.1304 61.5404 129.971 30.7123 168.116 30.7123C204.058 30.7123 233.623 58.1795 236.754 93.2958",
    stroke: "currentColor",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.493 175.813C87.0725 158.429 71.8841 130.498 71.8841 99.0905C71.8841 46.2423 114.667 3.47687 167.536 3.47687C214.493 3.47687 253.681 37.4342 261.681 82.0539",
    stroke: "currentColor",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.623 343.862C361.739 345.484 361.739 347.223 361.739 348.845C361.739 436.578 290.667 507.622 202.899 507.622C115.13 507.622 44.058 436.578 44.058 348.845C44.058 261.112 115.13 190.068 202.899 190.068C224.348 190.068 244.87 194.357 263.536 202.006",
    stroke: "currentColor",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.319 469.956C269.554 469.956 324.058 415.473 324.058 348.266C324.058 281.058 269.554 226.575 202.319 226.575C135.084 226.575 80.5797 281.058 80.5797 348.266C80.5797 415.473 135.084 469.956 202.319 469.956Z",
    stroke: "currentColor",
    strokeWidth: 13
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.319 445.038C255.787 445.038 299.13 401.712 299.13 348.266C299.13 294.819 255.787 251.493 202.319 251.493C148.851 251.493 105.507 294.819 105.507 348.266C105.507 401.712 148.851 445.038 202.319 445.038Z",
    stroke: "currentColor",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.319 406.213C234.335 406.213 260.29 380.269 260.29 348.266C260.29 316.262 234.335 290.318 202.319 290.318C170.303 290.318 144.348 316.262 144.348 348.266C144.348 380.269 170.303 406.213 202.319 406.213Z",
    stroke: "currentColor",
    strokeWidth: 13
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.899 384.773C222.749 384.773 238.841 368.688 238.841 348.845C238.841 329.003 222.749 312.918 202.899 312.918C183.048 312.918 166.957 329.003 166.957 348.845C166.957 368.688 183.048 384.773 202.899 384.773Z",
    stroke: "currentColor",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.334 246.625C277.103 235.499 289.392 227.734 303.421 225.88C305.624 225.532 307.943 225.417 310.146 225.417C337.74 225.417 360.001 247.784 360.001 275.252C360.001 283.944 357.798 292.172 353.856 299.242C347.132 311.411 335.537 320.451 321.624 323.696",
    stroke: "currentColor",
    strokeWidth: 13
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.014 302.023C327.768 299.705 337.391 288.579 337.391 275.252C337.391 260.185 325.217 248.016 310.145 248.016C300.406 248.016 291.826 253.116 287.072 260.88",
    stroke: "currentColor",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.667 230.864C241.855 219.042 251.826 209.191 263.536 202.006C276.638 194.009 291.942 189.489 308.406 189.489C311.188 189.489 313.971 189.605 316.638 189.837C360.464 194.009 394.783 230.864 394.783 275.831C394.783 284.06 393.623 291.94 391.536 299.358C386.435 317.206 375.884 332.62 361.623 343.746C350.725 352.322 337.623 358.348 323.362 360.782",
    stroke: "currentColor",
    strokeWidth: 12,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.899 157.154C250.203 138.727 268.174 125.746 289.275 125.746C301.913 125.746 313.507 130.498 322.319 138.263C326.725 142.204 330.435 146.839 333.333 152.055C337.043 159.124 339.246 167.121 339.246 175.582C339.246 177.32 339.13 179.174 339.014 180.913",
    stroke: "currentColor",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.319 153.098C204.29 110.217 242.667 78.2294 288.696 78.2294C322.783 78.2294 352.812 95.8455 369.971 122.501C376.348 121.574 382.841 121.111 389.565 121.111C467.362 121.111 530.435 184.158 530.435 261.924C530.435 339.573 467.594 402.505 390.029 402.736",
    stroke: "currentColor",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.217 191.111C342.261 175.697 364.754 166.31 389.565 166.31C442.435 166.31 485.217 209.075 485.217 261.924C485.217 312.106 446.609 353.249 397.449 357.19",
    stroke: "currentColor",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.319 202.701C364.638 196.559 376.696 192.966 389.565 192.966C427.71 192.966 458.551 223.794 458.551 261.924C458.551 297.503 431.536 326.825 396.87 330.534",
    stroke: "currentColor",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.594 226.923C382.957 225.996 386.435 225.416 390.145 225.416C410.667 225.416 427.246 241.99 427.246 262.503C427.246 282.553 411.362 298.778 391.536 299.59V299.474C395.594 315.12 397.681 331.461 397.681 348.266C397.681 456.164 310.261 543.549 202.319 543.549C94.3768 543.549 6.95652 456.164 6.95652 348.266C6.95652 240.367 94.3768 152.982 202.319 152.982C244.985 152.982 284.522 166.658 316.638 189.837",
    stroke: "currentColor",
    strokeWidth: 13
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.203 385.236C460.29 382.802 513.043 328.563 513.043 261.924C513.043 193.777 457.739 138.495 389.565 138.495C385.855 138.495 382.145 138.611 378.551 138.959C372.174 139.538 365.797 140.581 359.652 142.088C357.101 136.525 353.855 131.425 350.145 126.674C335.884 108.478 313.623 96.7726 288.58 96.7726C252.87 96.7726 222.725 120.647 213.333 153.33",
    stroke: "currentColor",
    strokeWidth: 15
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceDetailsPattern);
export default __webpack_public_path__ + "static/media/service-details-pattern.ff87f5c0b030063100d21c9d2ab0cd914d14cabc0cf3b152bb54e669619cd91a.svg";
export { ForwardRef as ReactComponent };